import * as React from 'react'
import { View, StyleSheet, Text } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default function NeedsSignIn() {
  return (
    <View style={styles.container}>
      <Text>ログインが必要です。</Text>
    </View>
  )
}
